// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu.md ion-list {
  padding: 20px 0;
}

ion-menu.md ion-note {
  margin-bottom: 30px;
}

ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}

ion-menu.md ion-list#inbox-list {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}

ion-menu.md ion-list#inbox-list ion-list-header {
  font-size: 22px;
  font-weight: 600;
  min-height: 20px;
}

ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;
  margin-bottom: 18px;
  color: #757575;
  min-height: 26px;
}

ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.md ion-item ion-icon {
  color: #616e7e;
}

ion-menu.md ion-item ion-label {
  font-weight: 500;
}

ion-menu.ios ion-content {
  --padding-bottom: 20px;
}

ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}

ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: #73849a;
}

ion-menu.ios ion-list#labels-list ion-list-header {
  margin-bottom: 8px;
}

ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}

ion-menu.ios ion-note {
  margin-bottom: 8px;
}

ion-note {
  display: inline-block;
  font-size: 16px;
  color: var(--ion-color-medium-shade);
}

ion-item.selected {
  --color: var(--ion-color-primary);
}

ion-avatar {
  margin: 2%;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,2EAAA;AACF;;AAEA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;EAEE,kBAAA;AACF;;AAEA;EACE,2DAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EAEA,gBAAA;AAAF;;AAGA;EACE,eAAA;EAEA,mBAAA;EAEA,cAAA;EAEA,gBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,sDAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;;EAEE,kBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,eAAA;EAEA,oCAAA;AAJF;;AAOA;EACE,iCAAA;AAJF;;AAOA;EACE,UAAA;AAJF","sourcesContent":["ion-menu ion-content {\r\n  --background: var(--ion-item-background, var(--ion-background-color, #fff));\r\n}\r\n\r\nion-menu.md ion-content {\r\n  --padding-start: 8px;\r\n  --padding-end: 8px;\r\n  --padding-top: 20px;\r\n  --padding-bottom: 20px;\r\n}\r\n\r\nion-menu.md ion-list {\r\n  padding: 20px 0;\r\n}\r\n\r\nion-menu.md ion-note {\r\n  margin-bottom: 30px;\r\n}\r\n\r\nion-menu.md ion-list-header,\r\nion-menu.md ion-note {\r\n  padding-left: 10px;\r\n}\r\n\r\nion-menu.md ion-list#inbox-list {\r\n  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);\r\n}\r\n\r\nion-menu.md ion-list#inbox-list ion-list-header {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n\r\n  min-height: 20px;\r\n}\r\n\r\nion-menu.md ion-list#labels-list ion-list-header {\r\n  font-size: 16px;\r\n\r\n  margin-bottom: 18px;\r\n\r\n  color: #757575;\r\n\r\n  min-height: 26px;\r\n}\r\n\r\nion-menu.md ion-item {\r\n  --padding-start: 10px;\r\n  --padding-end: 10px;\r\n  border-radius: 4px;\r\n}\r\n\r\nion-menu.md ion-item.selected {\r\n  --background: rgba(var(--ion-color-primary-rgb), 0.14);\r\n}\r\n\r\nion-menu.md ion-item.selected ion-icon {\r\n  color: var(--ion-color-primary);\r\n}\r\n\r\nion-menu.md ion-item ion-icon {\r\n  color: #616e7e;\r\n}\r\n\r\nion-menu.md ion-item ion-label {\r\n  font-weight: 500;\r\n}\r\n\r\nion-menu.ios ion-content {\r\n  --padding-bottom: 20px;\r\n}\r\n\r\nion-menu.ios ion-list {\r\n  padding: 20px 0 0 0;\r\n}\r\n\r\nion-menu.ios ion-note {\r\n  line-height: 24px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\nion-menu.ios ion-item {\r\n  --padding-start: 16px;\r\n  --padding-end: 16px;\r\n  --min-height: 50px;\r\n}\r\n\r\nion-menu.ios ion-item.selected ion-icon {\r\n  color: var(--ion-color-primary);\r\n}\r\n\r\nion-menu.ios ion-item ion-icon {\r\n  font-size: 24px;\r\n  color: #73849a;\r\n}\r\n\r\nion-menu.ios ion-list#labels-list ion-list-header {\r\n  margin-bottom: 8px;\r\n}\r\n\r\nion-menu.ios ion-list-header,\r\nion-menu.ios ion-note {\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n}\r\n\r\nion-menu.ios ion-note {\r\n  margin-bottom: 8px;\r\n}\r\n\r\nion-note {\r\n  display: inline-block;\r\n  font-size: 16px;\r\n\r\n  color: var(--ion-color-medium-shade);\r\n}\r\n\r\nion-item.selected {\r\n  --color: var(--ion-color-primary);\r\n}\r\n\r\nion-avatar{\r\n  margin: 2%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
